import React from 'react';
import { YStack, XStack, Button, Text } from 'tamagui';
import { tokens } from 'tamagui-config';

interface UnlockKeypadProps {
  onNumberClick: (number: string) => void;
}

export const UnlockKeypad: React.FC<UnlockKeypadProps> = ({ onNumberClick }) => {
  // Create rows of numbers for the keypad
  const numberRows = [[1, 2, 3], [4, 5, 6], [7, 8, 9], [0]];

  return (
    <YStack width="100%" height="100%" alignItems="center" gap="$3">
      {numberRows.map((row, index) => (
        <XStack key={index} justifyContent="center" gap="$3">
          {row.map((number) => (
            <Button
              key={number}
              width={80}
              height={80}
              backgroundColor={tokens.color.gray3}
              borderRadius="50%"
              alignItems="center"
              onPress={() => onNumberClick(number.toString())}
              pressStyle={{ transform: [{ scale: 0.95 }] }}>
              <Text fontFamily="$body" fontSize="$7" fontWeight="$4" color={tokens.color.textLight}>
                {number}
              </Text>
            </Button>
          ))}
        </XStack>
      ))}
    </YStack>
  );
};
